export const tickerItems = [
  '09:12 综艺话题节点整理补录三条早期素材',
  '10:45 新增人物索引 12 条，支持首字母定位',
  '13:20 多方来源交叉核对，重复条目合并处理',
  '15:08 八月整期归档打包完成，可离线下载',
  '17:36 事件脉络补全至第 4 阶段',
  '20:02 「影视剧集」分区新增两组合集',
];

export const breakingFeed = [
  {
    time: '09:12',
    tag: '合集更新',
    title: '综艺话题节点整理补录三条早期素材',
    detail: '按时间顺序归入「综艺圈 · 早期节点」合集，重复来源已标注。',
  },
  {
    time: '10:45',
    tag: '索引新增',
    title: '新增人物索引 12 条，支持按首字母定位',
    detail: '索引入口已同步更新，人物与事件之间可双向跳转。',
  },
  {
    time: '13:20',
    tag: '来源汇总',
    title: '多方来源交叉核对，重复条目合并处理',
    detail: '合并后合集条目更清晰，减少同一条内容的反复出现。',
  },
  {
    time: '15:08',
    tag: '归档',
    title: '八月归档打包完成，可整期下载',
    detail: '整期压缩包已上线，下载入口固定放在页面底部下载区。',
  },
  {
    time: '17:36',
    tag: '脉络',
    title: '事件脉络补全至第 4 阶段',
    detail: '脉络图新增两个关键节点，按阶段可折叠展开查看。',
  },
  {
    time: '20:02',
    tag: '合集更新',
    title: '「影视剧集」分区新增两组合集',
    detail: '分类分区同步刷新，入口保持醒目，方便直接进入。',
  },
];

export const navEntries = [
  {
    id: 'person',
    icon: 'ri-user-search-line',
    title: '人物索引',
    desc: '按姓名首字母定位，先查人再反查相关事件。',
    count: '1,284 条',
    badge: '索引',
  },
  {
    id: 'event',
    icon: 'ri-timeline-view',
    title: '事件脉络',
    desc: '按起始时间把零散节点串成完整时间线。',
    count: '326 条',
    badge: '时间线',
  },
  {
    id: 'collections',
    icon: 'ri-book-2-line',
    title: '合集归档',
    desc: '分主题打包成期，支持整期连续浏览。',
    count: '92 期',
    badge: '合集',
  },
  {
    id: 'source',
    icon: 'ri-links-line',
    title: '来源速查',
    desc: '多方原始来源入口并列对照，便于核实。',
    count: '47 个源',
    badge: '来源',
  },
  {
    id: 'daily',
    icon: 'ri-flashlight-line',
    title: '每日快讯',
    desc: '当天整理动态按时间刷新，先看新到的。',
    count: '今日 18 条',
    badge: '快讯',
  },
  {
    id: 'archive',
    icon: 'ri-archive-2-line',
    title: '归档下载',
    desc: '整期打包下载，离线也能慢慢翻看。',
    count: '离线包',
    badge: '下载',
  },
];

export const featuredCollections = [
  {
    id: 'c092',
    code: '第 092 期',
    title: '综艺圈 · 早期节点整理',
    summary:
      '把散落在多方来源里的早期素材，按时间和人物重新排成一条可读的线，读起来不再东一块西一块。',
    tags: ['时间线', '人物整理'],
    meta: '共 218 条 · 09-12 更新',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20flat%20lay%20of%20stacked%20cream%20paper%20archive%20cards%20and%20a%20thin%20vermillion%20index%20tab%20on%20a%20clean%20warm%20beige%20surface%2C%20soft%20diffused%20natural%20light%2C%20gentle%20shadows%2C%20muted%20amber%20accent%2C%20minimal%20editorial%20composition%20with%20generous%20empty%20background%20space&width=1000&height=720&seq=mag17-col-001&orientation=landscape',
  },
  {
    id: 'c091',
    code: '第 091 期',
    title: '直播话题 · 节点对照',
    summary: '同一话题的不同来源并排摆放，标出时间差与重复条目，谁先谁后一眼看清。',
    tags: ['来源对照', '去重'],
    meta: '共 164 条 · 09-09 更新',
    image: '',
  },
  {
    id: 'c090',
    code: '第 090 期',
    title: '影视剧集 · 讨论节点合集',
    summary: '按剧集分章，收录公开讨论里反复出现的时间点，章节之间互不串味。',
    tags: ['分章', '剧集'],
    meta: '共 132 条 · 09-05 更新',
    image: '',
  },
  {
    id: 'c089',
    code: '第 089 期',
    title: '网络人物 · 索引速查',
    summary: '从人物入口进入，反查相关事件与合集位置，适合已经有目标的人。',
    tags: ['索引', '反查'],
    meta: '共 96 条 · 09-02 更新',
    image: '',
  },
];

export const personGroups = [
  { letter: 'C', names: ['陈××', '崔×', '曹××'] },
  { letter: 'G', names: ['高××', '郭×', '顾××'] },
  { letter: 'L', names: ['林××', '刘××', '罗×'] },
  { letter: 'S', names: ['孙××', '宋××', '沈×'] },
  { letter: 'W', names: ['王××', '吴××', '魏×'] },
  { letter: 'Z', names: ['张××', '赵××', '周×'] },
];

export const eventTimeline = [
  {
    date: '2026.03',
    stage: '阶段一',
    title: '话题首次进入公开来源',
    summary: '多方来源出现零散记录，条目开始按日期归档。',
  },
  {
    date: '2026.05',
    stage: '阶段二',
    title: '来源交叉核对与去重',
    summary: '重复条目被合并，合集结构第一次成型。',
  },
  {
    date: '2026.07',
    stage: '阶段三',
    title: '人物与事件双向索引上线',
    summary: '既可以从人物查到事件，也能从事件回看人物。',
  },
  {
    date: '2026.08',
    stage: '阶段四',
    title: '八月整期归档发布',
    summary: '整期打包成册，支持离线慢慢翻看。',
  },
  {
    date: '2026.09',
    stage: '持续',
    title: '每日快讯常态化更新',
    summary: '当天整理动态按时间刷新，先看快的再进合集。',
  },
];

export const categories = [
  { icon: 'ri-tv-2-line', title: '综艺圈', desc: '节目与嘉宾相关节点', count: 318 },
  { icon: 'ri-live-line', title: '直播话题', desc: '直播片段与实况记录', count: 204 },
  { icon: 'ri-film-line', title: '影视剧集', desc: '剧集与角色相关讨论', count: 176 },
  { icon: 'ri-music-2-line', title: '音乐现场', desc: '舞台与演出相关素材', count: 92 },
  { icon: 'ri-gamepad-line', title: '电竞游戏', desc: '赛事与选手相关节点', count: 145 },
  { icon: 'ri-newspaper-line', title: '媒体动态', desc: '报道与稿件来源汇总', count: 88 },
  { icon: 'ri-user-star-line', title: '网络人物', desc: '网络红人与话题人物', count: 231 },
  { icon: 'ri-links-line', title: '来源速查', desc: '原始来源入口对照', count: 47 },
];

export const stats = [
  { value: '1,284', label: '索引条目' },
  { value: '92', label: '归档期数' },
  { value: '326', label: '事件节点' },
  { value: '47', label: '来源站点' },
];

export const archiveList = [
  { index: '第 092 期', title: '综艺圈早期节点整理', category: '综艺圈', updated: '09-12' },
  { index: '第 091 期', title: '直播话题节点对照', category: '直播话题', updated: '09-09' },
  { index: '第 090 期', title: '影视剧集讨论节点', category: '影视剧集', updated: '09-05' },
  { index: '第 089 期', title: '网络人物索引速查', category: '网络人物', updated: '09-02' },
  { index: '第 088 期', title: '电竞赛事节点汇总', category: '电竞游戏', updated: '08-29' },
  { index: '第 087 期', title: '音乐现场素材整理', category: '音乐现场', updated: '08-25' },
  { index: '第 086 期', title: '媒体稿件来源对照', category: '媒体动态', updated: '08-21' },
  { index: '第 085 期', title: '来源速查入口更新', category: '来源速查', updated: '08-18' },
];